import styled from 'styled-components';

export const JobEditWrapper = styled.div`
  .ant-form-item {
    width: 288px;
  }
`;
